import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import { Banner } from './Banner';
import { MobileModal } from './MobileModal';
import { Spacer } from '@lafabrica/core';

const OuterWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: auto;
    z-index: 2;
`;

const Wrapper = styled.div`
  position: relative;
  padding: 0px 10px;
  height: 50px;
  ${props => props.transparent ?
    `background: none;` :
    `background-color: ${props.headerBackgroundColor};
    `
  }
  ${props => props.boxShadow && !props.transparent &&
    `box-shadow: 0px 0px 4px 4px rgba(0,0,0,0.15);`
  }

  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(100vw - 20px);

  @media only screen and (min-width: 769px) {
    padding: 0px 40px;
    width: calc(100vw - 80px);
    height: 80px;
  }
`;

const MobileWrapper = styled(Wrapper)`
  width: calc(100% - 40px);
  padding: 0px 20px;
`;

const HorizontalSpacer = styled.div`
  flex: 1;
`

const NavWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`

export const Header = ({logo, nav, headerBackgroundColor='var(--white)', transparent=false, boxShadow=false, includeBanner = false, bannerOnClick, bannerChildren, noMobile=false, mobileContent=null}) => {
  const [transparentHeader, setTransparentHeader] = useState(transparent);
  const [fixed, setFixed] = useState(false);
  const [showBanner, setShowBanner] = useState(includeBanner);
  const [showMenu, setShowMenu] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setTransparentHeader(transparent);
  }, [transparent])

  useEffect(() => {
    setShowBanner(includeBanner);
    setFixed(!includeBanner);
  }, [includeBanner])

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (transparent){
        const isVisible = currPos.y < -100;

        setTransparentHeader(!isVisible);
      }

      const position = wrapperRef.current.getBoundingClientRect();
      if (!includeBanner){
        setFixed(true)
      } else if (!fixed && position.top < 0){
        setFixed(true);
      } else if (fixed && currPos.y >= -80){
        setFixed(false);
      }

      if (!transparent && transparentHeader){
        setTransparentHeader(false)
      }
    },
    [transparentHeader]
  );

  if (!noMobile && isMobile){
    return (
      <OuterWrapper>
        {
          showBanner &&
          <Banner onClick={bannerOnClick}>
            {bannerChildren}
          </Banner>
        }
        <MobileWrapper transparent={transparentHeader} ref={wrapperRef} style={fixed ? {position: 'fixed', top: 0} : {}}
          headerBackgroundColor={headerBackgroundColor}>
          {logo}
          <HorizontalSpacer />
          <FontAwesomeIcon
            icon={faBars}
            color={headerBackgroundColor === 'var(--white)' ? 'var(--black)' : 'var(--white)'}
            style={{ marginRight: 10, marginTop: 8, cursor: 'pointer' }}
            onClick={() => setShowMenu(true)}
          />
        </MobileWrapper>
        <MobileModal visible={showMenu} close={() => setShowMenu(false)}
          backgroundColor={headerBackgroundColor} logo={logo}>
          {mobileContent ?
            mobileContent :
            <Fragment>
              {logo}
              <Spacer />
              {nav}
            </Fragment>
          }
        </MobileModal>
      </OuterWrapper>
    )
  }

  return (
      <OuterWrapper>
        {
          showBanner &&
          <Banner onClick={bannerOnClick}>
            {bannerChildren}
          </Banner>
        }
        <Wrapper transparent={transparentHeader} headerBackgroundColor={headerBackgroundColor}
          boxShadow={boxShadow} ref={wrapperRef}
          style={fixed ? {position: 'fixed', transition: 'all 200ms ease-in', top: 0} : {transition: 'all 200ms ease-out', top: 0}}>
          {logo}
          <HorizontalSpacer />
          <NavWrapper>{nav}</NavWrapper>
        </Wrapper>
      </OuterWrapper>

  );
};
